




import { Component, Prop, Watch } from "vue-property-decorator";
import { APIError, BadRequest, GenericError } from "@/services/error_service";
import { CustomUmbrella } from "@/models/configurator/custom_umbrella";
import { UmbrellaData } from "@/mixins/umbrella";
import { mixins } from "vue-class-component";
import SpecService from "@/services/spec_service";
import { EventBus } from "@/event-bus";

@Component
export default class Download extends mixins(UmbrellaData) {
  @Prop({ default: null }) images?: string[];
  @Prop({ default: "" }) configShortCode!: string;
  @Prop({ default: false }) isDownloading!: boolean;
  @Prop({ default: null }) expiration!: Date | null;
  @Prop({ default: false }) isRAQ!: boolean;
  protected specService = new SpecService();
  protected storedPdf: Blob | undefined = undefined;

  protected async getShareCodeAndDownloadSpecs(): Promise<void> {
    if (this.isRAQ && this.storedPdf && this.isDownloading) {
      this.forcePdfDownload(this.storedPdf);
      return;
    }
    this.$emit("downloadSpecs");
  }

  @Watch("configShortCode", { immediate: true })
  protected onShortCodeChange(): void {
    this.runDownloadIfReady();
  }

  @Watch("isDownloading")
  protected onDownloadingChange(): void {
    this.runDownloadIfReady();
  }

  protected async runDownloadIfReady(): Promise<void> {
    if (this.configShortCode === "" || !this.isDownloading) return;
    const loader = this.$loading.show(
      { opacity: 1 },
      { before: this.$createElement("h1", "Generating spec sheet...") }
    );
    try {
      if (this.isRAQ && this.storedPdf) {
        this.forcePdfDownload(this.storedPdf);
      } else if (!this.images) {
        EventBus.$emit("getStaticImages", this.getPdf);
      } else {
        await this.getPdf(this.images);
      }
      setTimeout(() => {
        loader.hide();
      }, 1000);
    } catch (err) {
      GenericError.popup(err.message);
      loader.hide();
    }
  }

  protected async getPdf(images: string[]): Promise<void> {
    const umbrella = this.getUmbrellaObject();
    await this.createPdfRequest({
      images: images,
      shortcode: this.configShortCode,
      specs: umbrella,
      expiration: this.expiration
    });
  }

  protected async createPdfRequest(
    body: {
      images: string[];
      shortcode: string;
      specs: CustomUmbrella;
      expiration: Date | null;
    },
    loader?: any
  ): Promise<any> {
    let pdf;
    try {
      const res = await this.specService.downloadSpecs(body);
      pdf = res;
      if (this.isRAQ) this.storedPdf = res;
      this.forcePdfDownload(pdf);
    } catch (err) {
      if (err instanceof BadRequest) {
        BadRequest.popup(err.message, err.statusCode);
      } else if (err instanceof GenericError) {
        GenericError.popup(err.message);
      } else {
        APIError.popup(err.message, err.statusCode);
      }
      if (loader) {
        setTimeout(() => {
          loader.hide();
        }, 2000);
      }
    }
    return pdf;
  }

  protected forcePdfDownload(pdf: Blob): void {
    const date = new Date().toLocaleDateString("en-US").replace(/\//g, "-");
    const url = window.URL.createObjectURL(new Blob([pdf]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "Frankford_Umbrella_Specs_" + date + ".pdf");
    document.body.appendChild(link);
    link.click();
  }
}
